import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { PrintTemplateDto } from './printTemplate.dto';
export class PrintTemplateAvailabilityDto extends BaseDto{

    printTemplate: PrintTemplateDto;

    merchantId?: number;
    merchant?: MerchantDto;


    global: boolean;
}